export default "__VITE_ASSET__BcT8USlg__";